var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-select", {
                attrs: {
                  label: _vm.$ct("components.models.operator"),
                  items: _vm.operators,
                  value: _vm.operator,
                  fancy: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.setOperator($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-input", {
                attrs: {
                  value: _vm.searchValue,
                  label: _vm.$ct("text"),
                  fancy: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.setSearchValue($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }